import { createApiClient } from "@eduviaos/shared";

/**
 * Singleton API client for this portal. The super-admin surface is the
 * platform itself — it always operates against the special
 * `_super_admin` tenant, regardless of host. We hardcode the slug here
 * so a misconfigured DNS or browser quirk can't accidentally route a
 * super-admin login through a real tenant.
 *
 * The `onUnauthorized` callback is wired up post-construction by the
 * AuthProvider so a stale-cookie 401 round-trip can flush the
 * in-memory access token and redirect to login.
 */
export const SUPER_ADMIN_TENANT_SLUG = "_super_admin";

export const api = createApiClient({
  baseURL: import.meta.env.VITE_API_URL,
  tenantSlugProvider: () => SUPER_ADMIN_TENANT_SLUG,
});
